/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateRoundUpOnboardingFlowRequest} from '@cash-web/protos/squareup/cash/investautomator/api/flows/initiateRoundUpOnboardingFlow.pb'
import {InitiateRoundUpOnboardingFlowResponse} from '@cash-web/protos/squareup/cash/investautomator/api/flows/initiateRoundUpOnboardingFlow.pb'


export const initiateRoundUpOnboardingFlow = (request: InitiateRoundUpOnboardingFlowRequest, options?: CashRequestOptions) => post<InitiateRoundUpOnboardingFlowRequest, InitiateRoundUpOnboardingFlowResponse>("/cash-app/investing/initiate-round-up-onboarding-flow", request, {...options, rejectOnError: true })